<div class="tier-slider-container" *ngIf="tiers.length > 0">
  <div class="tier-labels">
    <span *ngFor="let tier of tiers; let i = index"
          class="tier-label"
          [class.active]="i === selectedIndex"
          (click)="selectedIndex = i; modelChange.emit(tier.model)">
      {{ tier.label }}
      <span class="tier-multiplier">{{ multiplierLabel(tier) }}</span>
    </span>
  </div>
  <input
    type="range"
    class="tier-range"
    [min]="0"
    [max]="maxIndex"
    [value]="selectedIndex"
    (input)="onSliderChange($event)"
    [attr.aria-label]="'Model quality tier'"
  />
  <div class="tier-ticks">
    <span *ngFor="let tier of tiers; let i = index"
          class="tier-tick"
          [class.active]="i === selectedIndex">
    </span>
  </div>
</div>
